import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useLoggedIn } from "../routes/isLoggedIn";
import { RootState } from "../store";
import { useAnalytics } from "./AnalyticsContext";
import { VISITOR_EVENTS, PageVisitEventData } from "./events";
import { usePageTimer } from "../hooks/usePageTimer";

export const PageVisitTracker = () => {
  const { trackEvent, setUser } = useAnalytics();

  const isAuthenticated = useLoggedIn();
  const userId = useSelector((state: RootState) => state.user?.id);
  const { pathname } = useLocation();

  // Track page timing
  usePageTimer(userId, isAuthenticated);

  useEffect(() => {
    const pageVisitData: PageVisitEventData = {
      page_path: pathname,
      page_title: document.title,
      is_authenticated: isAuthenticated,
      referrer: document.referrer || undefined,
    };

    if (isAuthenticated && userId) {
      pageVisitData.user_id = userId;
      setUser(userId);
    }

    trackEvent(
      `${VISITOR_EVENTS.PAGE_VISITED} ${pathname}`,
      pageVisitData as Record<string, unknown>,
    );
  }, [isAuthenticated, userId, pathname, setUser, trackEvent]);

  return null;
};
